module.exports = __webpack_public_path__ + "img/user.9ee9fa63.png";